module.exports = __webpack_public_path__ + "img/Spazi_scorrimento4.6cee82bd.webp";